import { render, staticRenderFns } from "./UserManualComponent.vue?vue&type=template&id=2dbb3fca"
import script from "./UserManualComponent.vue?vue&type=script&lang=js"
export * from "./UserManualComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports